import React from 'react';
import { useTranslation } from 'react-i18next';
import FlairIcon from '../../../../../atomic/atoms/FlairIcon';
import { ExpenseGroupStatusInfo } from '../types';
import { ExpenseGroupActions } from './ExpenseGroupActions';
import { ExpenseGroup } from '../../../__generated__/graphql';

interface ExpenseTileActionsProps {
  expenseType: string;
  isGroup: boolean;
  isExpanded: boolean;
  isMyExpenses: boolean;
  expenseGroup?: ExpenseGroup;
  onShowDetailsClick: (e: React.MouseEvent) => void;
  onExpenseGroupStatusChange?: (info: ExpenseGroupStatusInfo) => Promise<void>;
}

export const ExpenseTileActions: React.FC<ExpenseTileActionsProps> = ({
  expenseType,
  isGroup,
  isExpanded,
  isMyExpenses,
  expenseGroup,
  onShowDetailsClick,
  onExpenseGroupStatusChange,
}) => {
  const { t } = useTranslation();

  return (
    <div className="expense-tile-actions pt-3 ms-4 ps-4 mb-4">
      <div className="expense-tile-type me-2">{expenseType}</div>
      {isGroup && (
        <div className="d-flex align-items-center gap-3">
          <button
            type="button"
            className="expense-show-details-btn"
            onClick={onShowDetailsClick}>
            <span>{t('expenses.groups.showDetails')}</span>
            <FlairIcon
              icon={
                isExpanded ? 'chevron-up-outline' : 'chevron-forward-outline'
              }
              size="sm"
            />
          </button>
          {!isMyExpenses && onExpenseGroupStatusChange && expenseGroup && (
            <ExpenseGroupActions
              expenseGroup={expenseGroup}
              onStatusChange={onExpenseGroupStatusChange}
            />
          )}
        </div>
      )}
    </div>
  );
};
